import assign from "../assign/index.js";
export default function cloneObject(object) {
  return assign({}, object);
}